import { saveSearchSource } from '@bridebook/web/app-basic/lib/search/search-bar-info-slice';
import getSearchUrl from '@bridebook/toolbox/src/getSearchUrl';
import type { Slug } from '@bridebook/toolbox/src/types';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { extractPlaceName } from '@bridebook/web/app-shared/lib/search/utils/extract-place-name';

const useLoggedOutSearchBar = (source: string, searchBarEnabled: boolean, slug?: Slug) => {
  const [loading, setLoading] = useState(false);
  const [showIcon, setShowIcon] = useState(true);
  const router = useRouter();
  const dispatch = useDispatch();

  const onPlaceSelected = useCallback(
    async (place: google.maps.places.PlaceResult) => {
      dispatch(saveSearchSource(source));
      setLoading(true);
      const placeName = extractPlaceName(place);
      await router.push(
        getSearchUrl({ slug: slug ?? 'venue', area: placeName.toLowerCase(), as: true }),
      );
      setLoading(false);
    },
    [dispatch, router, source, slug],
  );

  const handleOnFocus = useCallback(() => {
    setShowIcon(false);
  }, []);

  const handleOnBlur = useCallback(() => {
    setShowIcon(true);
  }, []);

  return {
    loading,
    showIcon,
    onPlaceSelected,
    handleOnFocus,
    handleOnBlur,
    searchBarEnabled,
  };
};

export default useLoggedOutSearchBar;
